<template>
  <v-card
    tile
    class="full-height black"
  >
    <v-btn
      icon
      dark
      large
      absolute
      top
      right
      style="z-index: 1;"
      @click="close"
    >
      <v-icon>
        close
      </v-icon>
    </v-btn>

    <video-player
      show-player-actions
      :video-options="{
        sources: [
          {
            src: videoSrc,
            type: 'video/mp4',
          },
        ]
      }"
    />

    <div
      :style="{
        position: 'absolute',
        left: 0,
        bottom: 0,
      }"
      class="full-width px-6 pb-2 d-flex justify-center"
    >
      <v-btn
        dark
        icon
        width="100"
        height="100"
        @click="showGenderSelection = true"
      >
        <v-icon
          size="40"
        >
          send
        </v-icon>
      </v-btn>
    </div>

    <v-dialog
      v-model="showGenderSelection"
    >
      <gender-selection
        :on-submit="submit"
        :current-action="currentAction"
        :on-close="() => showGenderSelection = false"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { DirectUpload } from '@rails/activestorage';
import VideoPlayer from '@/components/VideoPlayer.vue';
import { getAccessToken } from '@/store/utils';

export default {
  components: {
    VideoPlayer,
    GenderSelection: () => import('./GenderSelection.vue'),
  },

  data: () => ({
    url: `${process.env.VUE_APP_API_URL}/api/v2/direct_uploads`,
    showGenderSelection: false,
  }),

  computed: {
    ...mapGetters({
      dialogProps: 'dialog/dialogProps',
    }),

    imageUploaded() {
      return this.dialogProps.imageUploaded;
    },

    videoSrc() {
      return URL.createObjectURL(this.file);
    },

    file() {
      return this.dialogProps.file;
    },

    finally() {
      return this.dialogProps.finally;
    },

    currentAction() {
      return this.dialogProps.currentAction;
    },
  },

  methods: {
    ...mapActions({
      closeDialog: 'dialog/closeDialog',
      locateUser: 'currentLocation/locateUser',
    }),

    /**
     * Expects payload with the following attributes:
     * - gender
     * - allowContactQueries
     * - allowImageComments
     *
     * @param payload
     *
     * @param payload.gender
     * @param payload.allowContactQueries
     * @param payload.allowImageComments
     *
     * @returns {Promise<unknown>}
     */
    async submit(payload) {
      if (!this.$currentLocation) {
        await this.locateUser();
      }

      if (!this.$currentLocation) {
        this.$notifyError({ msg: 'Videota ei voitu lähettää, koska sijainti ei ole saatavilla' });
        this.closeDialog();
        return;
      }

      const params = {
        blob: this.file,
        ...payload,
      };

      await this.uploadVideo(params);
    },

    async uploadVideo({ blob, ...rest }) {
      const video = await this.uploadBlob(blob);

      if (!video) return;

      await this.imageUploaded({ video, ...rest });
      this.closeDialog();
    },

    async uploadBlob(blob) {
      const directUploader = new DirectUpload(blob, this.url, this);

      try {
        const image = await new Promise((resolve, reject) => {
          directUploader.create((error, returnedBlob) => {
            if (error) return reject();

            return resolve(returnedBlob.signed_id);
          });
        });

        return image;
      } catch (e) {
        this.$notifyError({ msg: 'Videon lähettäminen epäonnistui' });
        return null;
      }
    },

    directUploadWillCreateBlobWithXHR(xhr) {
      xhr.setRequestHeader('Authorization', `Token token=${getAccessToken()}`);

      xhr.upload.addEventListener('progress', this.directUploadDidProgress);
    },

    directUploadWillStoreFileWithXHR(xhr) {
      xhr.upload.addEventListener('progress', this.directUploadDidProgress);
    },

    directUploadDidProgress({ loaded, total }) { // eslint-disable-line
      // const progress = (loaded / total) * 100;
      // console.log('progress: ', progress); // eslint-disable-line
    },

    close() {
      this.finally();
    },
  },
};
</script>
